import { useMemo } from 'react'
import { motion } from 'framer-motion'
import { Check, X } from 'lucide-react'

export default function Polaroid({ photo, adminMode, onApprove, onDelete }) {
  const isPending = photo.status === 'pending'
  const rotation = useMemo(() => Math.random() * 4 - 2, [])

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.9 }}
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      <div className={`polaroid ${isPending && adminMode ? 'pending' : ''}`}>
        <img
          src={photo.url}
          alt={`Shot by ${photo.artist} using g6 mini camera`}
          className="polaroid-image"
          loading="lazy"
        />
        {isPending && adminMode && (
          <span className="polaroid-pending-tag">PENDING</span>
        )}
        <p className="polaroid-artist">{photo.artist}</p>

        {adminMode && isPending && (
          <div className="polaroid-actions">
            <button
              onClick={() => onApprove(photo.id)}
              className="polaroid-btn polaroid-btn-approve"
              aria-label="Approve"
            >
              <Check size={14} />
            </button>
            <button
              onClick={() => onDelete(photo.id)}
              className="polaroid-btn polaroid-btn-delete"
              aria-label="Delete"
            >
              <X size={14} />
            </button>
          </div>
        )}
      </div>
    </motion.div>
  )
}
